import * as React from 'react';
import { Link, OutsideClick, Popup, PopupArrow } from '@cian/components';
import { mergeStyles } from '@cian/utils';
import { ReliableIcon } from './ReliableIcon';
import { trackProblemIconHover, trackProblemMoreButtonClick } from '../../../../utils/tracking';
import * as style from './index.css';

export interface IPromoFlagProps {
  url: string;
  GKId: number;
}

export interface IPromoFlagState {
  showPopup: boolean;
}

export class ReliablePopup extends React.Component<IPromoFlagProps, IPromoFlagState> {
  public state = {
    showPopup: false,
  };

  private onProblemIconHover = () => {
    const { GKId } = this.props;
    trackProblemIconHover('reliable', GKId);
  };

  private onMoreButtonClick = () => {
    const { GKId } = this.props;
    trackProblemMoreButtonClick('reliable', GKId);
  };

  public render() {
    const { showPopup } = this.state;

    return (
      <span onMouseEnter={this.toggle(true)}>
        <OutsideClick onOutsideClick={this.toggle(false)} rootElement={<div className={style['container']} />}>
          <span
            {...mergeStyles(style['button'], showPopup ? style['green-hover'] : style['green'])}
            onClick={() => this.toggle(true)}
            onMouseEnter={this.onProblemIconHover}
          >
            <div className={style['icon-small']}>
              <ReliableIcon />
            </div>
            Проверено ЦИАН
          </span>
          {showPopup && this.renderPopup()}
        </OutsideClick>
      </span>
    );
  }
  private renderPopup() {
    let { url = '' } = this.props;

    if (url) {
      url = `${url}#reliable`;
    }

    return (
      <span className={style['wrapper']} onMouseLeave={this.toggle(false)}>
        <Popup arrow={PopupArrow.NONE} containerStyle={style['popup']}>
          <div {...mergeStyles(style['icon'], style['green'])}>
            <ReliableIcon />
          </div>
          <strong className={style['title']}>Проверено ЦИАН</strong>
          <p className={style['description']}>В ЖК есть корпуса, проверенные ЦИАН.</p>
          {url && (
            <Link
              onClick={this.onMoreButtonClick}
              href={url}
              theme="button/blueLightSolid"
              linkStyle={style['link']}
              target="_blank"
            >
              Узнать подробнее
            </Link>
          )}
        </Popup>
      </span>
    );
  }

  private toggle = (showPopup: boolean) => () => {
    this.setState({
      showPopup,
    });
  };
}
